import React, {useCallback} from "react";
import {Link, useHistory} from "react-router-dom";

const PageHeaderRow = (props) => {
  const history = useHistory();

  const handleGoBack = useCallback(() => {
    if (history.length > 1) {
      history.goBack();
    } else {
      history.push(props.goBackLink ?? "/");
    }
  }, [history, props.goBackLink]);

  return (
    <div id="page-header">
      {
        props.goBackLink &&
        <div className="back-button-container">
          <div onClick={handleGoBack} className="back-button-container base-button icon-button evo-blue">
            <span className="material-icons">chevron_left</span>
          </div>
        </div>
      }

      <div id="page-title-container">
        <p className="page-pretitle">{props.pretitle}</p>
        <h1 className="page-title">{props.h1}</h1>
      </div>

      <div id="page-breadcrumb">
        <ol className="breadcrumb">
          {props.breadcrumbs.map((item) => {
            return (
              <li className="breadcrumb-item" key={item.label}>
                <Link to={item.link}>{item.label}</Link>
              </li>
            );
          })}
          <span className="material-icons">chevron_right</span>
          <li className="breadcrumb-item active">
            {props.isMobile ? props.mobileCurrentPageLabel : props.h1}
          </li>
        </ol>
      </div>
    </div>
  );
};

export default PageHeaderRow;
